/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import DocsLayout from '../../components/DocsLayout';
import NextPage from '../../components/NextPage';
import Motivation from '../../sections/basics/motivation.mdx';
import GettingStarted from '../../sections/basics/getting-started.mdx';
import ComingFromCSS from '../../sections/basics/coming-from-css.mdx';
import Installation from '../../sections/basics/installation.mdx';
import PassedProps from '../../sections/basics/passed-props.mdx';
import AdaptingBasedOnProps from '../../sections/basics/adapting-based-on-props.mdx';
import StylingAnyComponents from '../../sections/basics/styling-any-component.mdx';
import ExtendingStyles from '../../sections/basics/extending-styles.mdx';
import AttachingAdditionalProps from '../../sections/basics/attaching-additional-props.mdx';
import Animations from '../../sections/basics/animations.mdx';
import ReactNative from '../../sections/basics/react-native.mdx';
const MDXLayout = ({children}) => _jsx(DocsLayout, {
  title: "基础",
  description: "开始了解 styled-components 基础知识。",
  children: children
});
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Motivation, {}), "\n", _jsx(Installation, {}), "\n", _jsx(GettingStarted, {}), "\n", _jsx(AdaptingBasedOnProps, {}), "\n", _jsx(ExtendingStyles, {}), "\n", _jsx(StylingAnyComponents, {}), "\n", _jsx(PassedProps, {}), "\n", _jsx(ComingFromCSS, {}), "\n", _jsx(AttachingAdditionalProps, {}), "\n", _jsx(Animations, {}), "\n", _jsx(ReactNative, {}), "\n", _jsx(NextPage, {
      href: "/docs/advanced",
      title: "高级"
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
